// extracted by mini-css-extract-plugin
export var content = "_q8-1";
export var noScroll = "_q8-3";
export var paper = "_q8-0";
export var scrollable = "_q8-2";